import { GraphQLClient } from 'graphql-request';
import React from 'react';

import {
  navigationInfo,
  project_slug,
  project_slug_path,
} from 'components/utils';
import Layout from 'components/Layout';
const graphcms = new GraphQLClient(process.env.NEXT_PUBLIC_GRAPHCMS);
import Content from 'components/hygraph/content';
import Footer from 'components/__dynamic/footer';
import Header from 'components/__dynamic/header';

export async function getStaticProps({ params }) {
  const { projectSlug } = await graphcms.request(project_slug, {
    slug: params.slug,
  });

  if (!projectSlug) {
    return {
      notFound: true,
    };
  }

  const { navigation } = await graphcms.request(navigationInfo);

  return {
    props: { projectSlug, navigation },
    revalidate: 2,
  };
}

export async function getStaticPaths() {
  const { projectSlugs } = await graphcms.request(project_slug_path);

  return {
    paths: projectSlugs.map(({ slug }) => ({
      params: { slug },
    })),
    fallback: true,
  };
}

const ProjectSlug = ({ projectSlug, navigation }) => {
  const ogData = {
    title: projectSlug?.ogData?.title,
    description: projectSlug?.ogData?.description,
    image: { url: projectSlug?.ogData?.image?.url },
    // url: projectSlug?.ogData?.url,
  };

  return projectSlug ? (
    <Layout metaData={ogData}>
      <Header
        backgroundColor="white"
        textColor="figma-secondaryone"
        textColorHover="figma-primary"
        dropdownColor="figma-primary"
        navigation={navigation}
      />
      <Content content={projectSlug?.content} />
      <Footer navigation={navigation} />
    </Layout>
  ) : (
    <div>Laster inn...</div>
  );
};

export default ProjectSlug;
